module.exports = __webpack_public_path__ + "static/media/outdoor.262dc7a2.png";